/**
 * Minimal async key/value contract redux-persist's `storage` option needs — structurally
 * compatible with its own `Storage` interface. Mobile implements the same shape over
 * AsyncStorage, so persisted-slice code (once added) stays portable between apps.
 */
export interface KeyValueStorage {
  getItem: (key: string) => Promise<string | null>;
  setItem: (key: string, value: string) => Promise<void>;
  removeItem: (key: string) => Promise<void>;
}

export const localStorageAdapter: KeyValueStorage = {
  getItem: (key) => Promise.resolve(window.localStorage.getItem(key)),
  setItem: (key, value) => {
    window.localStorage.setItem(key, value);
    return Promise.resolve();
  },
  removeItem: (key) => {
    window.localStorage.removeItem(key);
    return Promise.resolve();
  },
};

// sessionStorage-backed variant for slices that must not outlive the tab (see the impersonation
// slice's nested persistReducer in store.ts).
export const sessionStorageAdapter: KeyValueStorage = {
  getItem: (key) => Promise.resolve(window.sessionStorage.getItem(key)),
  setItem: (key, value) => {
    window.sessionStorage.setItem(key, value);
    return Promise.resolve();
  },
  removeItem: (key) => {
    window.sessionStorage.removeItem(key);
    return Promise.resolve();
  },
};
